import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "statistics-tabs" }
const _hoisted_2 = { class: "statistics-tabs__body" }
const _hoisted_3 = { class: "statistics-tabs__title" }
const _hoisted_4 = { class: "statistics-tabs__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "first-tab", {}, undefined, true),
        _renderSlot(_ctx.$slots, "second-tab", {}, undefined, true)
      ])
    ])
  ]))
}